import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { FileUploadService } from './services/file-upload.service';
import { ProductAliasService } from './services/product-alias.service';
import { AccountService } from './services/account.service';
import { UserService } from './services/user.service';
import { AuthService } from './services/auth.service';
import { PreferencesService } from './services/preferences.service';
import { ProjectService } from './services/project.services';
import { NotificationService } from './services/notification.service';
import { ApprovalService } from '../api/services/approval.service';
import { TasksService } from './services/tasks.service';
import { ReportService } from './services/report.services';


@NgModule({
  imports: [ CommonModule, HttpClientModule ],
  providers: [
    FileUploadService,
    ProductAliasService,
    PreferencesService,
    AccountService,
    UserService,
    AuthService,
    ProjectService,
    NotificationService,
    ApprovalService,
    TasksService,
    ReportService
  ]
})
export class ApiModule {
    public static forRoot(): ModuleWithProviders {
      return {
        ngModule: ApiModule
      };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import your base AppModule only.');
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/api.module.ts